<!--
 * @Author: czj
 * @Date: 2025-04-14 15:42:24
 * @Description: 
 * @FilePath: \sanshu-report-new\src\components\ImageCom\SingleImgCom.vue
-->
<template>
  <div class="image_container">
    <img class="img_fluid" :src="fileSrc" alt="">
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import PubSub from 'pubsub-js';

  const emit = defineEmits([])
  const props = defineProps(['node_data']);

  const is_show = ref(false);
  const fileSrc = ref('');//当前显示的文件

  const node_data_token = ref(null);// 节点数据token


  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(() => {
    node_data_token.value = PubSub.subscribe(`files_${props.node_data.title}`, function (msg, data) {
      if (data.imgBase) {
        is_show.value = true;
        fileSrc.value = data.imgBase;
      } else {
        is_show.value = false;
      };
    });

  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
    if (node_data_token.value) PubSub.unsubscribe(node_data_token.value);
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style scoped>
  /*   .image_container {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .img_fluid {
    max-width: 100%;
    max-height: 400px;
    object-fit: contain;
  } */

  .image_container {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .img_fluid {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
</style>